/*  App
    file: lib/router.js
*/
import Vue from 'vue';
import Router from 'vue-router';
import store from './store'
import Home from '../views/Home.vue';
import Checks from '../components/Checks.vue';
import Login from '../components/Login.vue';
import Reports from '../components/Reports.vue';
// import Reports_Statusevents from '../components/Reports_Statusevents.vue';  // added in route when needed.
import Signup from '../components/Signup.vue';

var starting = Date.now(), initialized;

// const pathmap = {
//     '/dist': 'reports',
//     '/reports/statusevents': 'reports/statusevents'
// }

Vue.use(Router);

let router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            redirect: (window._nppn && window._nppn.length) ? window._nnpn : '/app'
        },
        {
            path: '/app',
            name: 'home',
            component: Home,
            meta: { requiresAuth: true }
        },
        {
            path: '/app/checks',
            name: 'checks data path',
            component: Checks,
            meta: { requiresAuth: true }
        },
        {
            path: '/checks',
            name: 'checks',
            component: Checks,
            meta: { requiresAuth: true }
        },
        {
            path: '/reports',
            name: 'reports',
            component: Reports,
            children: [
                {
                    path: 'statusevents',
                    name: 'statusevents no id',
                    component: () => import(/* webpackChunkName: "statusevents" */ '../components/Reports_Statusevents.vue')
                },
                {
                    path: 'statusevents/:reportid',
                    name: 'statusevents',
                    component: () => import(/* webpackChunkName: "statusevents" */ '../components/Reports_Statusevents.vue')
                },
                {
                    path: 'statusevents/check/:cid',
                    name: 'check status report',
                    component: () => import(/* webpackChunkName: "checkstatus" */ '../components/Reports_Checkstatus.vue')
                },
                {
                    path: 'statusevents/check/:cid/:limit',
                    name: 'check status report id',
                    component: () => import(/* webpackChunkName: "checkstatus" */ '../components/Reports_Checkstatus.vue')
                },
                {
                    path: 'checkstatus/:cid',
                    name: 'check status report short path',
                    component: () => import(/* webpackChunkName: "checkstatus" */ '../components/Reports_Checkstatus.vue')
                },
                {
                    path: 'statusevents/:uuid/check',
                    name: 'check status report alternative route',
                    component: () => import(/* webpackChunkName: "checkstatus" */ '../components/Reports_Checkstatus.vue')
                }
            ]
        },
        {
            path: '/login',
            name: "login",
            component: Login,
            meta: { requiresNoAuth: true }
        },
        {
            path: '/signup',
            name: "signup",
            component: Signup,
            meta: { requiresNoAuth: true }
        },
        {
            path: '/about',
            name: 'about',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
        },
        {
            path: '*',
            name: 'default',
            component: Login,
            meta: { requiresNoAuth: true }
        }
    ]
});

// router.beforeEach((to, from, next) => {
//     console.log(window.location, to);
//     for (let i in pathmap){
//         if (window.location.pathname.match(i) && to.name !== pathmap[i]){
//             next({ replace: pathmap[i] });
//         }
//     }
//     next();
// });



router.beforeEach((to, from, next) => {
    // console.log('routing', window._nppn, to);

    const checkroute = function () {
        if (store.state.initDone){
            // console.log('processing route', (Date.now() - starting), window.location.href, store.getters.currentUser && store.getters.currentUser.customer_id);
            if((to.path === "/" || to.path === "/app") && window._nppn && window._nppn.length){
                // initialized = true;
                // console.log(window._nppn);
                // next({
                //     path: window._ppnp
                // })
                // router.push({path: window._nppn});
                window.location = window._nppn;
            } else if (to.matched.some(record => record.meta.requiresAuth)) {
                if (store.getters.currentUser) {
                    next();
                } else {
                    // console.log('redirecting to login');
                    next({
                        path: '/login',
                        query: { redirect: to.fullPath }
                    });
                }
            } else if (to.matched.some(record => record.meta.requiresNoAuth) && store.getters.currentUser && store.getters.currentUser.customer_id){
                // console.log('redirecting to /');
                next({
                    path: '/'
                });
            } else {
                next();
            }
        } else {
            setTimeout(checkroute, 333);
        }
    }
    checkroute();
});
// setInterval(function () { console.log('checking for currentUser', (Date.now() - starting), store.getters.currentUser) }, 300);
export default router;
